import { ModeToggle } from "@shared/components/ModeToggle";
import { LanguageSwitcher } from "@shared/components/LanguageSwitcher";
import Logo from "@shared/components/Logo";
import DynamicBreadcrumb from "@shared/components/DynamicBreadcrumb";
// import NotificationDropdown from "@/features/settings/notification/NotificationList";
import { Separator } from "@shared/components/ui/separator";
import { useIsMobile } from "@shared/hooks/use-mobile";

const Navbar = ({ SidebarTrigger }) => {
  const isMobile = useIsMobile();
  return (
    <nav className="w-full">
      {/* Main navbar */}
      <div className="flex h-16 items-center justify-between px-4 md:px-6 lg:px-8">
        {/* Left Section - Sidebar trigger, page title and branding */}
        <div className="flex items-center gap-4 flex-1 min-w-0">
          {SidebarTrigger && (
            <SidebarTrigger className="text-foreground hover:bg-accent hover:text-accent-foreground rounded-md p-2 transition-colors flex-shrink-0" />
          )}
          <Separator
            orientation="vertical"
            className="h-6 bg-border/60 flex-shrink-0"
          />
          {/* Breadcrumb section */}
          {!isMobile && <DynamicBreadcrumb />}
          {/* Mobile logo */}
          <div className="md:hidden flex-shrink-0">
            <Logo className="h-8" />
          </div>
        </div>

        {/* Right Section - User actions and controls */}
        <div className="flex items-center gap-2 flex-shrink-0">
          {/* Theme and Language controls */}
          <div className="flex items-center gap-1 p-1 rounded-lg bg-muted/50">
            <ModeToggle />
            <LanguageSwitcher />
          </div>

          {/* Future: Add user avatar/menu or notifications */}
          {/* <Button variant="ghost" size="icon" className="relative">
            <Bell className="h-4 w-4" />
            <span className="absolute -top-1 -right-1 h-3 w-3 rounded-full bg-destructive text-[10px] font-medium text-destructive-foreground flex items-center justify-center">
              3
            </span>
          </Button> */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
